<h1 mat-dialog-title>Eliminar archivo</h1>
<div mat-dialog-content class="dialog-text">
  <p>¿Desea eliminar el archivo?</p>
  <p><strong>{{fName}}</strong></p>
</div>
<div mat-dialog-actions>
  <button class="btn btn--outline" mat-button
    (click)="cancel()">Cancelar</button>
  <button class="btn" mat-button cdkFocusInitial
    (click)="confirm()">Confirmar</button>
</div>
